module.exports = __webpack_public_path__ + "img/logo10.7c2c79d7.png";